<template>
  <div class="inner-card" :style="{ background: backgroundColor }">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <ValidationObserver v-slot="{ handleSubmit }">
      <table class="important-table">
        <tr>
          <th scope="row" style="width: 15%">
            <span :style="{ color: fontColor }">
              重視順序
              <p class="en-text">Order of importance</p>
            </span>
          </th>
          <th scope="row">
            <span :style="{ color: fontColor }">
              項目
              <p class="en-text">item</p>
            </span>
          </th>
          <th scope="row">
            <span :style="{ color: fontColor }">
              重視原因
              <p class="en-text">Reason of importance</p>
            </span>
          </th>
        </tr>

        <tr v-for="(data, index) in workConsideration" :key="index">
          <th scope="row">
            <span :style="{ color: fontColor }"> {{ ++index }} </span>
          </th>
          <td>
            <ValidationProvider
              class="w-100"
              v-slot="{ errors }"
              rules="required"
            >
              <el-select class="w-100" placeholder="請選擇" v-model="data.Item">
                <el-option
                  label="產業發展 (Industrial Development)"
                  :value="0"
                />
                <el-option label="職務內容 (Job content)" :value="1" />
                <el-option label="薪資待遇 (Salary)" :value="2" />
                <el-option label="訓練制度 (Training system)" :value="3" />
                <el-option label="公司福利 (Company benefit)" :value="4" />
                <el-option label="企業形象 (Corporate image)" :value="5" />
                <el-option label="工作環境 (Work environment)" :value="6" />
                <el-option label="工作地點 (Work location)" :value="7" />
                <el-option label="親友推薦 (Friend referral)" :value="8" />
                <el-option label="其他 (Others)" :value="9" />
              </el-select>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </td>
          <td>
            <input
              type="text"
              maxlength="50"
              autocomplete="off"
              readonly
              @focus="$common.removeReadonly($event)"
              v-model="data.Reason"
            />
          </td>
        </tr>
      </table>

      <div class="edit-btn-wrap">
        <!-- 儲存 -->
        <button
          type="button"
          class="put-btn"
          @click="handleSubmit(saveWorkConsideration)"
        >
          {{ $t("BUTTON.RESUME_SAVE") }}
        </button>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["source", "nextTab", "matchId"],
  name: "AseIDLWorkConsideration",

  data() {
    return {
      workConsideration: [],

      backgroundColor: "#f1f1f1",
      fontColor: "#000",
    };
  },
  methods: {
    saveWorkConsideration() {
      const isDuplicate = this.workConsideration
        .map((element) => element.Item)
        .some((item, index, arr) => arr.indexOf(item) != index);
      if (isDuplicate) {
        this.$notify({
          title: "錯誤",
          message: "項目不可重複",
          type: "error",
          duration: 2500,
        });
        return;
      }

      this.$api.idl
        .putWorkConsideration(this.source, {
          Details: this.workConsideration,
          UserId:
            this.source === "resume" ? this.$cookies.get("candidateId") : null,
          MatchId: this.source === "personnelInformation" ? this.matchId : null,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "職缺需求儲存成功",
              type: "success",
              duration: 2000,
            });
            if (this.source === "resume") {
              this.$store.dispatch("GetResumeCompleteness");
            }
            this.getWorkConsideration();
            this.$emit("changeTab", this.nextTab);
          }
        });
    },

    // 取得 職缺需求
    getWorkConsideration() {
      const candidate =
        this.source === "resume"
          ? this.$cookies.get("candidateId")
          : this.matchId;
      this.updateLoading(true);
      this.$api.idl
        .getWorkConsideration(this.source, candidate)
        .then((response) => {
          if (response.status === 200) {
            this.workConsideration = response.data;
          }
          this.updateLoading(false);
        });
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  created() {
    this.getWorkConsideration();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};
</script>

<style lang="scss" scoped>
.en-text {
  opacity: 0.6;
  font-size: 0.85em;
}
.edit-btn-wrap {
  .put-btn {
    margin-top: 20px;
    border: none;
    border-radius: 5px;
    padding: 5px 10px;
    color: #fff;
    background: #18c58b;
  }
}
/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  color: #5b5b5b;
  cursor: default;
}
</style>
